import { API_REQUEST, GET_DOCUMENT, RESET_DOCUMENT} from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction } from "../../types";

export const getDocument = (formdata: Record<string, unknown>): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: "/download",
        next: GET_DOCUMENT,
        data: formdata,
        method: 'POST',
        authorization: true
    }
});

export const resetDocument = (): AppNoApiAction => ({
    type: RESET_DOCUMENT
});

